import gtm from '@/utils/gtm';
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { Icon } from './icon';
import './index.scss';
const EcoCreditsWinIn: any = dynamic(() => import('./EcoCreditsWinIn'), { ssr: false });

export default function EcoCreditsWin() {
    const [isOpen, setIsOpen] = useState(false);

    // 切换
    const toggleHandle = () => {
        if (!isOpen) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'floating_button',
                button_name: 'Web EF icon',
            });
        }
        setIsOpen(!isOpen);
    };

    // 关闭
    const closeHandle = () => {
        setIsOpen(false);
    };

    return (
        <>
            <div className={'EcoCreditsWin'} onClick={toggleHandle}>
                <div className="win-icon">
                    <Icon />
                </div>
            </div>
            {isOpen && (
                <div className="EcoCreditsWin-cover">
                    <EcoCreditsWinIn closeHandle={closeHandle} />
                </div>
            )}
        </>
    );
}
